import { createStore } from "vuex";

export default createStore({
  state: {
    token: "",
    userInfo: "",
    menus: "",
    roleList: "",
    departmentInfo: "",
    regionInfo: "",
  },
  mutations: {
    // set
    // state指state数据，token指传过来的数据
    TOKEN: (state, token) => {
      state.token = token;
      localStorage.setItem("token", token);
    },
    USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    MENUS: (state, menus) => {
      console.log("menus提交到store中");
      state.menus = menus;
      sessionStorage.setItem("menus", JSON.stringify(menus));
    },
    DEPARTMENT_INFO: (state, departmentInfo) => {
      state.departmentInfo = departmentInfo;
      sessionStorage.setItem("departmentInfo", JSON.stringify(departmentInfo));
    },
    ROLE_LIST: (state, roleList) => {
      state.roleList = roleList;
      sessionStorage.setItem("roleList", JSON.stringify(roleList));
    },
    REGION_INFO: (state, regionInfo) => {
      state.regionInfo = regionInfo;
      sessionStorage.setItem("regionInfo", JSON.stringify(regionInfo));
    },
    REMOVE_INFO: (state) => {
      state.token = "";
      localStorage.setItem("token", "");
      sessionStorage.setItem("userInfo", "");
      sessionStorage.setItem("menus", "");
      sessionStorage.setItem("departmentInfo", "");
      sessionStorage.setItem("regionInfo", "");
      sessionStorage.setItem("roleList", "");
      sessionStorage.setItem("employeeManage", "");
      sessionStorage.setItem("deptManageInfo", "");
      sessionStorage.setItem("roleMap", "");
    },
  },
  getters: {
    // 相当于计算属性，实时监听属性
    getUserInfo: (state) => {
      if (state.userInfo == "") {
        state.userInfo = sessionStorage.getItem("userInfo");
      }
      return JSON.parse(state.userInfo);
    },
    getDepartmentInfo: (state) => {
      if (state.departmentInfo == "") {
        state.departmentInfo = sessionStorage.getItem("departmentInfo");
      }
      return JSON.parse(state.departmentInfo);
    },
    getToken: (state) => {
      if (state.token == "") {
        state.token = localStorage.getItem("token");
      }
      return state.token;
    },
    getMenus: (state) => {
      if (state.menus == "") {
        state.menus = sessionStorage.getItem("menus");
      }
      return JSON.parse(state.menus);
    },
    getRoleList: (state) => {
      if (state.roleList == "") {
        state.roleList = sessionStorage.getItem("roleList");
      }
      return JSON.parse(state.roleList);
    },
    getRegionInfo: (state) => {
      if (state.regionInfo == "") {
        state.regionInfo = sessionStorage.getItem("regionInfo");
      }
      return JSON.parse(state.regionInfo);
    },
  },
  actions: {},
  modules: {},
});